import CalendarPage from "./CalendarPage";

export {CalendarPage}
export default CalendarPage
